import React from 'react';

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="container">
        <div className="page-header">
          <h1>About Zed Scholar</h1>
          <p>Empowering Zambian students to achieve academic excellence</p>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2>Our Mission</h2>
            <div className="mission-content">
              <p>
                At Zed Scholar, we're committed to democratizing quality education in Zambia. 
                We believe every student deserves access to excellent exam preparation resources, 
                regardless of their location or economic background. Our platform bridges the gap 
                between quality education and accessibility.
              </p>
              <p>
                We work tirelessly to ensure that Zambian students have the tools they need 
                to succeed in their examinations and build confidence for their academic journey.
              </p>
            </div>
          </section>

          <section className="about-section">
            <h2>What We Offer</h2>
            <div className="offerings-grid">
              <div className="offering-item">
                <div className="offering-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14,2 14,8 20,8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                    <polyline points="10,9 9,9 8,9"/>
                  </svg>
                </div>
                <h3>Comprehensive Study Materials</h3>
                <p>
                  Access curated past examination papers, detailed study guides, and targeted 
                  practice questions specifically designed for the Zambian ECZ curriculum. 
                  Our materials are regularly updated to match current examination standards.
                </p>
              </div>
              <div className="offering-item">
                <div className="offering-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <h3>AI-Powered Learning</h3>
                <p>
                  Get personalized support from our AI tutor available 24/7 to help you 
                  understand difficult concepts, practice problems, and track your progress 
                  with intelligent insights.
                </p>
              </div>
              <div className="offering-item">
                <div className="offering-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                </div>
                <h3>Learn Anywhere</h3>
                <p>
                  Study seamlessly on your computer through our web platform. 
                  Our responsive design ensures you can learn anytime, anywhere with consistent experience.
                </p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>Grade Levels We Support</h2>
            <div className="grade-levels">
              <div className="grade-level">
                <h3>Grade 7</h3>
                <p>Primary school examination preparation with focus on foundational subjects</p>
              </div>
              <div className="grade-level">
                <h3>Grade 12</h3>
                <p>Senior secondary school exam preparation for university entrance</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>Why Choose Zed Scholar?</h2>
            <div className="advantages">
              <div className="advantage">
                <div className="advantage-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <h4>Made for Zambia</h4>
                <p>
                  All our content is specifically designed for the Zambian ECZ curriculum 
                  and examination system. We understand the unique challenges and requirements 
                  of Zambian students because we're part of the same education ecosystem.
                </p>
              </div>
              <div className="advantage">
                <div className="advantage-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="1" x2="12" y2="23"/>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                  </svg>
                </div>
                <h4>Affordable Excellence</h4>
                <p>
                  Our subscription plans are thoughtfully priced to be accessible to all Zambian 
                  families while maintaining the highest quality of educational content and support.
                </p>
              </div>
              <div className="advantage">
                <div className="advantage-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </div>
                <h4>Local Expert Teachers</h4>
                <p>
                  All our content is created and reviewed by experienced Zambian educators 
                  who understand the curriculum, examination patterns, and student needs firsthand.
                </p>
              </div>
              <div className="advantage">
                <div className="advantage-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                  </svg>
                </div>
                <h4>Proven Success</h4>
                <p>
                  Join thousands of students across Zambia who have improved their exam performance 
                  and gained confidence through our comprehensive learning platform.
                </p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>Our Story</h2>
            <div className="story-content">
              <p>
                Zed Scholar was born from a simple observation: Zambian students deserved 
                better access to quality exam preparation resources. Our founders, experienced Zambian 
                educators, saw firsthand how unequal access to educational materials was 
                affecting student performance and confidence.
              </p>
              <p>
                Starting with just a handful of students, we've grown to serve thousands across 
                Zambia. Our journey has been guided by one principle: every student, regardless 
                of their circumstances, deserves the opportunity to excel academically and build 
                a brighter future.
              </p>
              <p>
                Today, we're more than just an ed-tech platform – we're a community of learners, 
                educators, and families united by the belief that quality education should be 
                accessible to all. We continue to innovate and improve, always keeping the needs 
                of Zambian students at the heart of everything we do.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
